import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ensureSWRegistered, pushSupported } from "@/lib/push";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import PassengerDashboard from "@/pages/PassengerDashboard";
import DriverDashboard from "@/pages/DriverDashboard";
import DriverAgenda from "@/pages/DriverAgenda";
import DriverStats from "@/pages/DriverStats";
import AdminDashboard from "@/pages/AdminDashboard";
import History from "@/pages/History";
import PaymentResult from "@/pages/PaymentResult";

function Protected({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><p className="font-mono-eyebrow">// Chargement...</p></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) {
    if (user.role === "admin") return <Navigate to="/admin" replace />;
    if (user.role === "driver") return <Navigate to="/driver" replace />;
    return <Navigate to="/passenger" replace />;
  }
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/passenger" element={<Protected role="passenger"><PassengerDashboard /></Protected>} />
      <Route path="/driver" element={<Protected role="driver"><DriverDashboard /></Protected>} />
      <Route path="/driver/agenda" element={<Protected role="driver"><DriverAgenda /></Protected>} />
      <Route path="/driver/stats" element={<Protected role="driver"><DriverStats /></Protected>} />
      <Route path="/admin" element={<Protected role="admin"><AdminDashboard /></Protected>} />
      <Route path="/history" element={<Protected><History /></Protected>} />
      <Route path="/payment-success" element={<Protected><PaymentResult kind="success" /></Protected>} />
      <Route path="/payment-cancel" element={<Protected><PaymentResult kind="cancel" /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  useEffect(() => {
    if (pushSupported()) ensureSWRegistered();
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
